var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39777 6.16281L3.36027 1.44719C3.34449 1.43477 3.32553 1.42705 3.30557 1.42492C3.2856 1.42279 3.26544 1.42633 3.2474 1.43514C3.22936 1.44395 3.21417 1.45768 3.20357 1.47473C3.19298 1.49179 3.18741 1.51149 3.1875 1.53156V2.56683C3.1875 2.63246 3.2183 2.6954 3.2692 2.73558L8.09063 6.50031L3.2692 10.265C3.21697 10.3052 3.1875 10.3682 3.1875 10.4338V11.4691C3.1875 11.5588 3.29063 11.6083 3.36027 11.5534L9.39777 6.83781C9.44908 6.79779 9.4906 6.74658 9.51915 6.6881C9.5477 6.62962 9.56254 6.56539 9.56254 6.50031C9.56254 6.43523 9.5477 6.37101 9.51915 6.31253C9.4906 6.25404 9.44908 6.20284 9.39777 6.16281Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.174726c36ac42db9a2e702f50c6e2bf9.svg";
export { ForwardRef as ReactComponent };